export interface TestRunSummary {
  // NOTE(bobsin): id isn't auto-populated by test_run_summaries, need to remove
  id: string;
  runId: string;
  scenarioId: string;
  operationId: string;
  runName: string;
  scenarioName: string;
  operationName: string;
  startedAt: number;
  stoppedAt: number;
  requests: number;
  failures: number;
  virtualUsers: number;
  latencyAvgMs: number;
  latencyMinMs: number;
  latencyMaxMs: number;
  latencyP50Ms: number;
  latencyP75Ms: number;
  latencyP90Ms: number;
  latencyP95Ms: number;
  latencyP99Ms: number;

  // NOTE(bobsin): these are derived
  requestsPerSecond: number;
  failureRate: number;
}

export interface TestRun {
  id: string;
  testScenarioId: string;
  name: string;
  publishStrategy?: string;
  startedAt?: string;
  stoppedAt?: string;
  createdAt?: string;
}

export interface SummariesByOperation {
  [operationName: string]: TestRunSummary;
}

export interface TestRunOperation {
  id: string;
  name: string;
}

export interface TestRunChart {
  operationName: string;
  timestamps: number[];
  requests: number[];
  failures: number[];
  virtualUsers: number[];
  latencyAvgMs: number[];
  latencyMinMs: number[];
  latencyMaxMs: number[];
  latencyP50Ms: number[];
  latencyP75Ms: number[];
  latencyP90Ms: number[];
  latencyP95Ms: number[];
  latencyP99Ms: number[];

  // NOTE(bobsin): these are derived
  requestsPerSecond: number[];
  failureRate: number[];
}

export interface ChartsByOperation {
  [operationName: string]: TestRunChart;
}

export enum TimeAggregationLevels {
  fiveSecond = '5s',
  thirtySecond = '30s',
  oneMinute = '1m',
  fiveMinute = '5m',
  thirtyMinute = '30m',
}

export type TimeAggregationLevel =
  | TimeAggregationLevels.fiveSecond
  | TimeAggregationLevels.thirtySecond
  | TimeAggregationLevels.oneMinute
  | TimeAggregationLevels.fiveMinute
  | TimeAggregationLevels.thirtyMinute;

export interface TestScenarioSummary {
  scenarioId: string;
  scenarioName: string;
  runs: number;
  requests: number;
  errorRate: number;
  avgVirtualUsers: number;
  avgLatencyAvgMs: number;
}
